import ReportTableDataRows from './report-table-data-rows-container'

export default ReportTableDataRows